import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../nodeIds';

export const weightUnit: AnswerPathTreeNode = { path: 'weightUnit', nodeId: NodeIds.insuredWeightUnit };
